(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const toggle = document.getElementById('mobileToggle');
  const navLinks = document.getElementById('navLinks');
  const overlay = document.getElementById('navOverlay');
  const nav = document.getElementById('siteNav');

  if (toggle && navLinks && overlay) {
    function closeMenu() {
      toggle.classList.remove('open');
      navLinks.classList.remove('open');
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    function openMenu() {
      toggle.classList.add('open');
      navLinks.classList.add('open');
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    }

    toggle.addEventListener('click', function () {
      const isOpen = navLinks.classList.contains('open');
      isOpen ? closeMenu() : openMenu();
    });

    overlay.addEventListener('click', closeMenu);

    // Close on escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });

    // Close on link click
    navLinks.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    // Scroll effect
    if (nav) {
      window.addEventListener('scroll', function () {
        if (window.scrollY > 50) {
          nav.classList.add('scrolled');
        } else {
          nav.classList.remove('scrolled');
        }
      });
    }
  }

  } catch(e) { console.error(e); }
})();
})();
